import {createSlice} from "@reduxjs/toolkit";
import {DATA_LIMIT} from "../../app/constants";

const cronjob = createSlice({
    name: "cronjob",
    initialState: {
        loading: false,
        error: null,
        filter: {
            page: 1,
            limit: DATA_LIMIT,
        },
        items: [],
        pagination: {
            page: 1,
            limit: DATA_LIMIT,
            total: 0,
        },
    },
    reducers: {
        fetchData(state) {
            state.loading = true;
            state.error = null;
            return state;
        },
        fetchDataSuccess(state, action) {
            state.loading = false;
            state.items = action.payload.data;
            if(action.payload?.pagination) {
                state.pagination = action.payload.pagination;
            }
            state.error = null;
            return state;
        },
        fetchDataFailed(state, action) {
            state.loading = false;
            state.error = action.payload;
            return state;
        },
        add(state, action) {
            state.items.unshift(action.payload);
            return state;
        },
        delete(state, action) {
            action.payload = parseInt(action?.payload);
            state.items = state.items.filter((item) => item.id !== action.payload);
            return state;
        },
        setFilter(state, action) {
            state.filter = action.payload;
            return state;
        },
        setFilterWithDebounce(state, action) {},
    },
});

export const cronjobActions = cronjob.actions;
export const cronjobReducer = cronjob.reducer;
export const cronjobItemsSelector = (state) => state.cronjob.items;
export const cronjobLoadingSelector = (state) => state.cronjob.loading;
export const cronjobErrorSelector = (state) => state.cronjob.error;
export const cronjobFilterSelector = (state) => state.cronjob.filter;
export const cronjobPaginationSelector = (state) => state.cronjob.pagination;
